function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import times from 'lodash/times';
import filter from 'lodash/filter';
import { AppContext } from 'context';
import history from 'helpers/history';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import urlRouteShape from 'shapes/urlRouteShape';
import App, { AlertsBus } from 'modules/App';
import Account, { InvitationInfo } from 'modules/Account';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './OrganizationInvitations.pcss';
var _React_PureComponent;
class OrganizationInvitations extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.organizationMemberships !== this.props.organizationMemberships) {
            if (!this.props.loadedIdentity) {
                return;
            }
            if (isEmpty(prevState.invitationMemberships)) {
                this.setInvitationMemberships();
            } else {
                this.updateInvitationMemberships();
            }
        }
    }
    onApproveMembership(organisationMembership) {
        this.props.onApproveMembership(organisationMembership);
    }
    onRejectMembership(organisationMembership) {
        this.props.onRejectMembership(organisationMembership);
    }
    get invitationMemberships() {
        return this.state.invitationMemberships;
    }
    setInvitationMemberships() {
        const invitationMemberships = this.filterInvitationMemberships(this.props.organizationMemberships);
        if (isEmpty(invitationMemberships)) {
            this.navigate();
            return;
        }
        this.setState({
            invitationMemberships
        });
    }
    filterInvitationMemberships(organizationMemberships) {
        return filter(organizationMemberships, (om)=>om.status === 'Invitation');
    }
    navigate() {
        const { name, params } = this.props.mainUrlRoute;
        const url = this.context.getUrl(name, params);
        history.push(url);
    }
    updateInvitationMemberships() {
        this.setState((state)=>{
            const invitationMemberships = map(state.invitationMemberships, (invitationMembership)=>{
                const { organizationUID } = invitationMembership;
                const organizationMembership = find(this.props.organizationMemberships, {
                    organizationUID
                });
                if (!organizationMembership) {
                    return _object_spread_props(_object_spread({}, invitationMembership), {
                        status: 'Rejected'
                    });
                }
                return invitationMembership.status === organizationMembership.status ? invitationMembership : organizationMembership;
            });
            const idx = findIndex(invitationMemberships, {
                status: 'Invitation'
            });
            if (idx < 0) {
                this.navigate();
                return null;
            }
            return {
                invitationMemberships
            };
        });
    }
    renderActions(organizationMembership) {
        if (organizationMembership.status === 'Invitation') {
            const { organizationUID } = organizationMembership;
            const approveActionType = `${Account.actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
            const isApproveInProgress = findIndex(this.props.approvesInProgress, (a)=>a === approveActionType) >= 0;
            const rejectActionType = `${Account.actionTypes.REJECT_ORGANIZATION_MEMBERSHIP}-${organizationUID}`;
            const isRejectInProgress = findIndex(this.props.rejectsInProgress, (a)=>a === rejectActionType) >= 0;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.approveMembership,
                        className: "btn--sm d-block w-100 px-4 mb-3",
                        isInProgress: isApproveInProgress,
                        isDisabled: isRejectInProgress,
                        onClick: ()=>this.onApproveMembership(organizationMembership)
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "secondary",
                        labelMessage: messages.buttons.rejectMembership,
                        className: "btn--sm d-block w-100 px-4",
                        isInProgress: isRejectInProgress,
                        isDisabled: isApproveInProgress,
                        onClick: ()=>this.onRejectMembership(organizationMembership)
                    })
                ]
            });
        }
        if (organizationMembership.status === 'Rejected') {
            return /*#__PURE__*/ _jsx("span", {
                className: "d-block w-100 text--error text--center text--bold",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.rejected))
            });
        }
        return /*#__PURE__*/ _jsx("span", {
            className: "d-block w-100 text--success text--center text--bold",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.approved))
        });
    }
    renderInvitationMembership(organizationMembership) {
        const { businessEmail, organization } = organizationMembership;
        const country = find(this.props.countries, {
            alpha2Code: organization.countryCode
        });
        const countryLabel = country ? get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName) : organization.countryCode;
        return /*#__PURE__*/ _jsx("li", {
            className: styles.organization,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            avatarImg: organization.logo,
                            name: organization.name,
                            className: styles.organization__logo,
                            imgClassName: styles.organization__logo__img,
                            initialsClassName: styles.organization__logo__initials
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row align-items-center",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-8",
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: styles.organization__name,
                                            children: organization.name
                                        }),
                                        /*#__PURE__*/ _jsxs("p", {
                                            className: styles.organization__property,
                                            children: [
                                                countryLabel,
                                                ", ",
                                                organization.city,
                                                ", ",
                                                organization.zipCode
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: styles.organization__property,
                                            children: businessEmail
                                        }),
                                        /*#__PURE__*/ _jsxs("p", {
                                            className: styles.organization__property,
                                            children: [
                                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.organizationId)),
                                                ": ",
                                                organization.organizationUID
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-4",
                                    children: this.renderActions(organizationMembership)
                                })
                            ]
                        })
                    })
                ]
            })
        }, organization.organizationUID);
    }
    renderClinicPlaceholder(idx) {
        return /*#__PURE__*/ _jsx("li", {
            className: `${styles.organization} ${styles['clinic--placeholder']}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row fadingLoader",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.organization__logo
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row align-items-center",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "col",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: `${styles.organization__name} w-50`
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: `${styles.organization__property} w-75`
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: `${styles.organization__property} w-25`
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        }, `i${idx}`);
    }
    renderOrganizations() {
        if (this.props.isFetchInProgress) {
            return /*#__PURE__*/ _jsx("ul", {
                className: styles.organizations,
                children: times(5, (idx)=>this.renderClinicPlaceholder(idx))
            });
        }
        if (isEmpty(this.invitationMemberships)) {
            return null;
        }
        return /*#__PURE__*/ _jsx("ul", {
            className: styles.organizations,
            children: map(this.invitationMemberships, (organizationMembership)=>this.renderInvitationMembership(organizationMembership))
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsx(InvitationInfo, {
                    className: "mb-6"
                }),
                /*#__PURE__*/ _jsxs("header", {
                    className: "pageHeader",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "text--h1",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers.invitationMemberships), {
                                values: {
                                    number: this.invitationMemberships.length
                                }
                            }))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "pageHeader__intro",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.invitationMemberships))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-5"
                }),
                this.renderOrganizations()
            ]
        });
    }
    constructor(props){
        super(props);
        const invitationMemberships = this.filterInvitationMemberships(props.organizationMemberships);
        this.state = {
            invitationMemberships
        };
    }
}
_define_property(OrganizationInvitations, "contextType", AppContext);
_define_property(OrganizationInvitations, "propTypes", {
    // Implicit props
    organizationMemberships: PropTypes.arrayOf(shapes.organizationMembership),
    loadedIdentity: Account.shapes.identity,
    mainUrlRoute: urlRouteShape,
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    isClientInitialized: PropTypes.bool.isRequired,
    isFetchInProgress: PropTypes.bool.isRequired,
    approvesInProgress: PropTypes.arrayOf(PropTypes.string),
    rejectsInProgress: PropTypes.arrayOf(PropTypes.string),
    // Implicit actions
    onApproveMembership: PropTypes.func,
    onRejectMembership: PropTypes.func,
    onSetFormValue: PropTypes.func
});
const mapStateToProps = (state)=>({
        isFetchInProgress: Account.selectors.isFetchOrganizationMembershipsInProgress(state),
        loadedIdentity: Account.selectors.loadedIdentity(state),
        mainUrlRoute: Account.selectors.mainUrlRoute(state),
        organizationMemberships: Account.selectors.organizationMemberships(state),
        approvesInProgress: Account.selectors.approveMembershipsInProgress(state),
        rejectsInProgress: Account.selectors.rejectMembershipsInProgress(state),
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state),
        isClientInitialized: App.selectors.isClientInitialized(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onApproveMembership: (organizationMembership)=>dispatch(Account.actions.approveOrganizationMembership(organizationMembership)),
        onRejectMembership: (organizationMembership)=>dispatch(Account.actions.rejectOrganizationMembership(organizationMembership))
    });
const ConnectedOrganizationInvitations = connect(mapStateToProps, mapDispatchToProps)(OrganizationInvitations);
export default withStyles(styles)(ConnectedOrganizationInvitations);
